import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, Star, Flame } from 'lucide-react';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden bg-brand-50" data-id="element-100">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[600px] h-[600px] bg-brand-200/40 rounded-full blur-3xl pointer-events-none" data-id="element-101" />
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-[500px] h-[500px] bg-emerald-200/30 rounded-full blur-3xl pointer-events-none" data-id="element-102" />

      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10" data-id="element-103">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-104">
          <div className="max-w-2xl" data-id="element-105">
            <FadeIn data-id="element-106">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-100 text-brand-700 font-medium text-sm mb-6" data-id="element-107">
                <span className="flex h-2 w-2 rounded-full bg-brand-500" data-id="element-108"></span>
                El Método de 30 Días
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-109">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-stone-900 leading-[1.1] mb-6 text-balance" data-id="element-110">
                Bajá de peso comiendo rico,{' '}
                <span className="text-brand-600" data-id="element-111">sin contar calorías</span> y
                usando solo tu Airfryer.
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-112">
              <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed" data-id="element-113">
                Airfryer Fit fue creado para personas reales, con poco tiempo,
                que quieren comer mejor, sentirse más livianas y aprovechar al
                máximo su Airfryer sin complicarse la vida.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-114">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 mb-10" data-id="element-115">
                <button onClick={scrollToOffer} className="bg-brand-600 hover:bg-brand-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg shadow-brand-500/30 hover:shadow-xl hover:-translate-y-1 w-full sm:w-auto text-center" data-id="element-116">
                  Quiero empezar hoy
                </button>
                <div className="flex items-center gap-2" data-id="element-117">
                  <span className="text-stone-400 line-through text-lg" data-id="element-118">
                    $29.999
                  </span>
                  <span className="text-2xl font-heading font-extrabold text-stone-900" data-id="element-119">
                    $14.999
                  </span>
                  <span className="bg-emerald-100 text-emerald-700 text-xs font-bold px-2 py-1 rounded-full" data-id="element-120">
                    -50%
                  </span>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-121">
              <div className="flex items-center gap-4 text-sm text-stone-600 font-medium" data-id="element-122">
                <div className="flex -space-x-2" data-id="element-123">
                  {[1, 2, 3, 4].map(i => <img key={i} src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Usuario" className="w-10 h-10 rounded-full border-2 border-white object-cover" data-id="element-124" />)}
                </div>
                <div data-id="element-125">
                  <div className="flex text-amber-400 mb-0.5" data-id="element-126">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-127" />)}
                  </div>
                  <p data-id="element-128">Más de 2,000 personas ya lo probaron</p>
                </div>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.2} direction="left" className="relative" data-id="element-129">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-130">
              <img src="https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?auto=format&fit=crop&w=1000&q=80" alt="Comida saludable en Airfryer" className="w-full h-full object-cover" data-id="element-131" />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/60 to-transparent" data-id="element-132" />
              <div className="absolute bottom-6 left-6 right-6 text-white" data-id="element-133">
                <div className="bg-white/20 backdrop-blur-md rounded-xl p-4 border border-white/30" data-id="element-134">
                  <div className="flex items-center gap-3 mb-2" data-id="element-135">
                    <CheckCircle2 className="w-6 h-6 text-emerald-400" data-id="element-136" />
                    <span className="font-bold text-lg" data-id="element-137">Plan resuelto</span>
                  </div>
                  <p className="text-white/90 text-sm" data-id="element-138">
                    Solo necesitás seguirlo. Cero estrés, 100% resultados.
                  </p>
                </div>
              </div>
            </div>

            {/* Floating badge */}
            <div className="absolute -top-6 -right-6 bg-white p-4 rounded-2xl shadow-xl animate-bounce" style={{
            animationDuration: '3s'
          }} data-id="element-139">
              <div className="flex items-center gap-2" data-id="element-140">
                <div className="bg-emerald-100 p-2 rounded-full text-emerald-600" data-id="element-141">
                  <Flame className="w-6 h-6" data-id="element-142" />
                </div>
                <div data-id="element-143">
                  <p className="text-xs text-stone-500 font-bold uppercase tracking-wider" data-id="element-144">
                    Formato
                  </p>
                  <p className="font-bold text-stone-900" data-id="element-145">Ebook Digital</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}